import React from "react";

export default function Section({ children, className = "", id, testId }) {
  return (
    <section id={id} data-testid={testId} className={`max-w-7xl mx-auto px-6 ${className}`}>
      {children}
    </section>
  );
}
